import { createAction } from 'redux-actions'
import { STOP } from '@/state/types/pageflip'

export const pageFlipStop = createAction(STOP)



// WEBPACK FOOTER //
// ./state/actions/pageflip.js